import { BzgModalRef, BZG_MODAL_DATA } from 'bz-genome-angular';
import { Component, Inject, ViewChild, ElementRef } from '@angular/core';


@Component({
    selector: 'deploymentPackageMaintenanceWindow',
    styleUrls: ['./package-maintenance-window.component.scss'],
    templateUrl: './package-maintenance-window.component.html'
})
export class DeploymentPackageMaintenanceWindowComponent {
    constructor(public modalComponentRef: BzgModalRef, @Inject(BZG_MODAL_DATA) public data: any) { }

    close() {
        this.modalComponentRef.close();
    }

    confirm() {
        this.modalComponentRef.close('confirm');
    }
}
